<ng-template #defaultView>
  <button (click)="clearOrganisation()" [disabled]="!multipleOrganisations" mat-button>
    {{organisation?.title}}
  </button>
</ng-template>

<ng-container *ngIf="organisations.length > 1; else defaultView">
  <button [matMenuTriggerFor]="organisationsMenu" mat-button class="profile-button">
    <div>{{organisation?.title}}</div>
    <mat-icon>expand_more</mat-icon>
  </button>

  <mat-menu #organisationsMenu="matMenu" [overlapTrigger]="false" class="organisation-menu">
    <button *ngFor="let org of organisations" (click)="selectOrganisation(org)" mat-menu-item class="menu-button">
      <span>{{org.title}}</span>
    </button>
  </mat-menu>
</ng-container>
